import React, { createContext, useContext } from "react";
import FormOneCard from "./Form/FormOneCard";
import ChartContainer from "./Chart/ChartContainer";

export default function MainBody() {
  return (
    <>
      <div className="flex flex-col justify-center items-center  mx-2 md:mx-5 lg:mx-5 my-8 z-50">
        <FormOneCard />
        <ChartContainer />
      </div>
    </>
  );
}
